import { getCurrentRegionId } from './getCurrentRegionId';
import { IAppState } from '../common/state';

export const getNewbuildingRentTrapUrl = (state: IAppState): string => {
  const regionId = getCurrentRegionId(state);

  return `/cat.php/?deal_type=sale&engine_version=2&has_decoration=1&from_developer=1&object_type%5B0%5D=2&offer_type=flat&region=${regionId}`;
};
